import React from 'react';
import { useDispatch } from 'react-redux';
import Signature from './Signature';

const SignaturePopup = ({ show, handleClose }) => {
  const dispatch = useDispatch();

  return (
    <>
      {show && (
       <div className="h-screen flex items-center justify-center bg-blue bg-opacity-50 border-4 border-blue-600" style={{ zIndex: 9999 }}>
          <div className="bg-white rounded-lg p-4 w-full max-w-2xl border-4 border-blue-600 shadow-lg">
            <h2 className="text-xl font-bold mb-2">Take Signature</h2> 
            <div className="mb-4">
              <Signature handleCloseSignature={handleClose} />
            </div>
            <div className="flex justify-end">
              <button
                className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SignaturePopup;
